module.exports = __webpack_public_path__ + "img/users-gear.a7d25121.svg";